// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html.dark pre code.hljs {
  display: block;
  overflow-x: auto;
  padding: 1em;
}
html.dark code.hljs {
  padding: 3px 5px;
}
html.dark .hljs {
  color: #abb2bf;
  background: #282c34;
}
html.dark .hljs-keyword,
html.dark .hljs-operator,
html.dark .hljs-pattern-match {
  color: #f92672;
}
html.dark .hljs-function,
html.dark .hljs-pattern-match .hljs-constructor {
  color: #61aeee;
}
html.dark .hljs-function .hljs-params {
  color: #a6e22e;
}
html.dark .hljs-function .hljs-params .hljs-typing {
  color: #fd971f;
}
html.dark .hljs-module-access .hljs-module {
  color: #7e57c2;
}
html.dark .hljs-constructor {
  color: #e2b93d;
}
html.dark .hljs-constructor .hljs-string {
  color: #9ccc65;
}
html.dark .hljs-comment,
html.dark .hljs-quote {
  color: #b18eb1;
  font-style: italic;
}
html.dark .hljs-doctag,
html.dark .hljs-formula {
  color: #c678dd;
}
html.dark .hljs-deletion,
html.dark .hljs-name,
html.dark .hljs-section,
html.dark .hljs-selector-tag,
html.dark .hljs-subst {
  color: #e06c75;
}
html.dark .hljs-literal {
  color: #56b6c2;
}
html.dark .hljs-addition,
html.dark .hljs-attribute,
html.dark .hljs-meta .hljs-string,
html.dark .hljs-regexp,
html.dark .hljs-string {
  color: #98c379;
}
html.dark .hljs-built_in,
html.dark .hljs-class .hljs-title,
html.dark .hljs-title.class_ {
  color: #e6c07b;
}
html.dark .hljs-attr,
html.dark .hljs-number,
html.dark .hljs-selector-attr,
html.dark .hljs-selector-class,
html.dark .hljs-selector-pseudo,
html.dark .hljs-template-variable,
html.dark .hljs-type,
html.dark .hljs-variable {
  color: #d19a66;
}
html.dark .hljs-bullet,
html.dark .hljs-link,
html.dark .hljs-meta,
html.dark .hljs-selector-id,
html.dark .hljs-symbol,
html.dark .hljs-title {
  color: #61aeee;
}
html.dark .hljs-emphasis {
  font-style: italic;
}
html.dark .hljs-strong {
  font-weight: 700;
}
html.dark .hljs-link {
  text-decoration: underline;
}
html pre code.hljs {
  display: block;
  overflow-x: auto;
  padding: 1em;
}
html code.hljs {
  padding: 3px 5px;
}
html code.hljs::-webkit-scrollbar {
  height: 4px;
}
html .hljs {
  color: #383a42;
  background: #ffffff;
}
html .hljs-comment,
html .hljs-quote {
  color: #a0a1a7;
  font-style: italic;
}
html .hljs-doctag,
html .hljs-formula,
html .hljs-keyword {
  color: #a626a4;
}
html .hljs-deletion,
html .hljs-name,
html .hljs-section,
html .hljs-selector-tag,
html .hljs-subst {
  color: #e45649;
}
html .hljs-literal {
  color: #0184bb;
}
html .hljs-addition,
html .hljs-attribute,
html .hljs-meta .hljs-string,
html .hljs-regexp,
html .hljs-string {
  color: #50a14f;
}
html .hljs-attr,
html .hljs-number,
html .hljs-selector-attr,
html .hljs-selector-class,
html .hljs-selector-pseudo,
html .hljs-template-variable,
html .hljs-type,
html .hljs-variable {
  color: #986801;
}
html .hljs-bullet,
html .hljs-link,
html .hljs-meta,
html .hljs-selector-id,
html .hljs-symbol,
html .hljs-title {
  color: #4078f2;
}
html .hljs-built_in,
html .hljs-class .hljs-title,
html .hljs-title.class_ {
  color: #c18401;
}
html .hljs-emphasis {
  font-style: italic;
}
html .hljs-strong {
  font-weight: 700;
}
html .hljs-link {
  text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/styles/highlight.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;;;EAGE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;;;;;;;;EAQE,cAAc;AAChB;AACA;;;;;;EAME,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,kBAAkB;AACpB;AACA;;;EAGE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;;;;EAQE,cAAc;AAChB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B","sourcesContent":["html.dark pre code.hljs {\n  display: block;\n  overflow-x: auto;\n  padding: 1em;\n}\nhtml.dark code.hljs {\n  padding: 3px 5px;\n}\nhtml.dark .hljs {\n  color: #abb2bf;\n  background: #282c34;\n}\nhtml.dark .hljs-keyword,\nhtml.dark .hljs-operator,\nhtml.dark .hljs-pattern-match {\n  color: #f92672;\n}\nhtml.dark .hljs-function,\nhtml.dark .hljs-pattern-match .hljs-constructor {\n  color: #61aeee;\n}\nhtml.dark .hljs-function .hljs-params {\n  color: #a6e22e;\n}\nhtml.dark .hljs-function .hljs-params .hljs-typing {\n  color: #fd971f;\n}\nhtml.dark .hljs-module-access .hljs-module {\n  color: #7e57c2;\n}\nhtml.dark .hljs-constructor {\n  color: #e2b93d;\n}\nhtml.dark .hljs-constructor .hljs-string {\n  color: #9ccc65;\n}\nhtml.dark .hljs-comment,\nhtml.dark .hljs-quote {\n  color: #b18eb1;\n  font-style: italic;\n}\nhtml.dark .hljs-doctag,\nhtml.dark .hljs-formula {\n  color: #c678dd;\n}\nhtml.dark .hljs-deletion,\nhtml.dark .hljs-name,\nhtml.dark .hljs-section,\nhtml.dark .hljs-selector-tag,\nhtml.dark .hljs-subst {\n  color: #e06c75;\n}\nhtml.dark .hljs-literal {\n  color: #56b6c2;\n}\nhtml.dark .hljs-addition,\nhtml.dark .hljs-attribute,\nhtml.dark .hljs-meta .hljs-string,\nhtml.dark .hljs-regexp,\nhtml.dark .hljs-string {\n  color: #98c379;\n}\nhtml.dark .hljs-built_in,\nhtml.dark .hljs-class .hljs-title,\nhtml.dark .hljs-title.class_ {\n  color: #e6c07b;\n}\nhtml.dark .hljs-attr,\nhtml.dark .hljs-number,\nhtml.dark .hljs-selector-attr,\nhtml.dark .hljs-selector-class,\nhtml.dark .hljs-selector-pseudo,\nhtml.dark .hljs-template-variable,\nhtml.dark .hljs-type,\nhtml.dark .hljs-variable {\n  color: #d19a66;\n}\nhtml.dark .hljs-bullet,\nhtml.dark .hljs-link,\nhtml.dark .hljs-meta,\nhtml.dark .hljs-selector-id,\nhtml.dark .hljs-symbol,\nhtml.dark .hljs-title {\n  color: #61aeee;\n}\nhtml.dark .hljs-emphasis {\n  font-style: italic;\n}\nhtml.dark .hljs-strong {\n  font-weight: 700;\n}\nhtml.dark .hljs-link {\n  text-decoration: underline;\n}\nhtml pre code.hljs {\n  display: block;\n  overflow-x: auto;\n  padding: 1em;\n}\nhtml code.hljs {\n  padding: 3px 5px;\n}\nhtml code.hljs::-webkit-scrollbar {\n  height: 4px;\n}\nhtml .hljs {\n  color: #383a42;\n  background: #ffffff;\n}\nhtml .hljs-comment,\nhtml .hljs-quote {\n  color: #a0a1a7;\n  font-style: italic;\n}\nhtml .hljs-doctag,\nhtml .hljs-formula,\nhtml .hljs-keyword {\n  color: #a626a4;\n}\nhtml .hljs-deletion,\nhtml .hljs-name,\nhtml .hljs-section,\nhtml .hljs-selector-tag,\nhtml .hljs-subst {\n  color: #e45649;\n}\nhtml .hljs-literal {\n  color: #0184bb;\n}\nhtml .hljs-addition,\nhtml .hljs-attribute,\nhtml .hljs-meta .hljs-string,\nhtml .hljs-regexp,\nhtml .hljs-string {\n  color: #50a14f;\n}\nhtml .hljs-attr,\nhtml .hljs-number,\nhtml .hljs-selector-attr,\nhtml .hljs-selector-class,\nhtml .hljs-selector-pseudo,\nhtml .hljs-template-variable,\nhtml .hljs-type,\nhtml .hljs-variable {\n  color: #986801;\n}\nhtml .hljs-bullet,\nhtml .hljs-link,\nhtml .hljs-meta,\nhtml .hljs-selector-id,\nhtml .hljs-symbol,\nhtml .hljs-title {\n  color: #4078f2;\n}\nhtml .hljs-built_in,\nhtml .hljs-class .hljs-title,\nhtml .hljs-title.class_ {\n  color: #c18401;\n}\nhtml .hljs-emphasis {\n  font-style: italic;\n}\nhtml .hljs-strong {\n  font-weight: 700;\n}\nhtml .hljs-link {\n  text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
